module.exports = __webpack_public_path__ + "img/activity-active.7ec16432.svg";